import { render, staticRenderFns } from "./ViewDetailsBattle.vue?vue&type=template&id=40eac418&scoped=true"
import script from "./ViewDetailsBattle.vue?vue&type=script&lang=js"
export * from "./ViewDetailsBattle.vue?vue&type=script&lang=js"
import style0 from "./ViewDetailsBattle.vue?vue&type=style&index=0&id=40eac418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40eac418",
  null
  
)

export default component.exports